module.exports = __webpack_public_path__ + "static/media/svgicons8-rating.912449dc.svg";